"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _pixelToNumber = _interopRequireDefault(require("../../style/pixelToNumber"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    height: 100%;\n    position: relative;\n    z-index: 2;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var base = function base(_ref) {
  var theme = _ref.theme;
  return {
    width: "calc(100% + ".concat(theme.pointerWidth, ")"),
    transform: "translateX(".concat((0, _pixelToNumber["default"])(theme.pointerWidth) / 2 * -1, "px)")
  };
};

var PointerWrapper = _styledComponents["default"].div(_templateObject(), function (props) {
  return base(props);
});

var _default = PointerWrapper;
exports["default"] = _default;